// extracted by mini-css-extract-plugin
export default {"showWrapper":"VisuallyHidden_showWrapper__zANYs","wrapper":"VisuallyHidden_wrapper__PehBq"};